'use client';
import React, { FC, useEffect, useState } from 'react';

import useAudioRoutingStore from 'state/audioRoutingStore';
import { publicAssets } from 'utils/gcs';

import S from './RotateDevice.module.scss';

import useScreenOrientation from 'hooks/useScreenOrientation';

export interface RotateDeviceProps {
  message?: string;
}

const RotateDevice: FC<RotateDeviceProps> = ({
  message = 'For optimal experience please turn\nyour device.',
}) => {
  const orientation = useScreenOrientation();
  const [isMounted, setIsMounted] = useState(false);
  const { setIsPlaying } = useAudioRoutingStore();

  useEffect(() => {
    setIsMounted(true);

    if (orientation?.startsWith('landscape')) setIsPlaying(false);
    else setIsPlaying(true);
  }, [orientation, setIsPlaying]);

  if (!isMounted) {
    return null;
  }

  return (
    orientation?.startsWith('landscape') && (
      <div className={S.RotateDevice}>
        <div className={S.DeviceWrapper}>
          <img src={publicAssets('/device.png')} />
        </div>

        <h3 className={S.Message}>{message}</h3>
      </div>
    )
  );
};
export default RotateDevice;
